import React from 'react';

const TagsFormModal = React.lazy(() => import('../components/FormModal'));
const tagsModalRegistry = {
    crm_tagsId: TagsFormModal
};
export default tagsModalRegistry;
